import React from "react"
import { createRoot } from "react-dom/client"
import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider } from "@mui/material/styles"
import theme from "./theme"
import { BrowserRouter as Router } from "react-router-dom"

import App from "./App"

const rootElement = document.getElementById("root")
const root = createRoot(rootElement!)

root.render(
  // <GoogleReCaptchaProvider
  //   reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}
  //   scriptProps={{ async: true, defer: true }}>
  // <LocalizationProvider dateAdapter={AdapterDateFns}>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Router future={{ v7_startTransition: true }}>
      <App />
    </Router>
  </ThemeProvider>
  // </LocalizationProvider>
  // </GoogleReCaptchaProvider>
)
